import { useCallback } from "react";
import { useAuth } from "@clerk/react";
import { API } from "@/lib/api";

export function useStream() {
  const { getToken } = useAuth();
  return useCallback(async (path, body, onText) => {
    const token = await getToken();
    const res = await fetch(`${API}${path}`, { method: "POST", headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` }, body: JSON.stringify(body) });
    if (!res.ok) {
      let detail = "";
      try { detail = (await res.json()).detail; } catch { detail = ""; }
      throw new Error(typeof detail === "string" && detail ? detail : "Une erreur est survenue.");
    }
    const reader = res.body.getReader();
    const dec = new TextDecoder();
    let buf = "";
    let full = "";
    for (;;) {
      const { done, value } = await reader.read();
      if (done) { break; }
      buf += dec.decode(value, { stream: true });
      const parts = buf.split("\n\n");
      buf = parts.pop();
      for (const p of parts) {
        if (!p.startsWith("data: ")) { continue; }
        const m = JSON.parse(p.slice(6));
        if (m.error) { throw new Error(m.error); }
        if (m.t) { full += m.t; onText(full); }
      }
    }
    return full;
  }, [getToken]);
}
